<template>

<span id="body">	
    <img class="wave" src="../assets/img/wave.png"/>
	<div class="container">
		<div class="img">
			<img src="../assets/img/bg.svg">
		</div>
		<div class="login-content">
			<form action="/" @submit.prevent="signin()">
				<img src="../assets/img/avatar.svg">
				<h2 class="title">Welcome</h2>
           		<div class="input-div one " :class="{ focus: isFocusA }">
           		   <div class="i">
           		   		<i class="fas fa-user"></i>
           		   </div>
           		   <div class="div">
           		   		<h5>Username</h5>
           		   		<input type="text" class="input input-sign-in" v-model="username" @focus="isFocusA = true" @blur="isFocusA = username.length>1 ? true: false"  maxlength="20">
           		   </div>
           		</div>
           		<div class="input-div pass" :class="{ focus: isFocusB }">
           		   <div class="i"> 
           		    	<i class="fas fa-lock"></i>
           		   </div>
           		   <div class="div">
           		    	<h5>Password</h5>
           		    	<input type="password" class="input input-sign-in" v-model="password"  @focus="isFocusB = true" @blur="isFocusB = password.length>1 ? true: false" maxlength="20" >
            	   </div>
            	</div>
            	<a href="#">{{feedback}}</a> 
            	<button type="submit" class="btn"  :class="{ disabled: isDisabled }">
                    <span v-if ="isDisabled == false ">Login</span>
                    <span  v-else>Please wait ....</span>
                </button>
            </form>
        </div>
    </div>
 </span> 


</template>
   
<script>
import {signUserIn,setup} from '@/model';
import {login} from '@/validator';

export default {
    name: 'SignIn',
    data() {
        return {
            isFocusA:false,
            isFocusB: false, 
           isDisabled:false,
           feedback:null,
           password:'',
           username:''
          
        };
    },
    mounted(){
        this.initialsetup();
        
    },
    methods:{
     initialsetup(){
          setup('admin','pass','Nwachukwu','male','nwachukwuchibuike2012@gmail.com','admin','09036040350');
      
     },
     signin(e){
        
        let self = this;
      if(this.username && this.password){
      let validator = login(this.username,this.password); 
      if(validator.status==false){
        this.feedback = validator.feedback;
         
        return false;
       
      }
       this.feedback = null;
       this.isDisabled = true;
       signUserIn(this.username.toLowerCase(),this.password,function(response){
       
       if(response){
           //console.log(response);
           self.feedback = "Account found, redirecting to dashboard";
           self.$store.commit('changeStaff', response);
           //console.log('I am new staff ',self.$store.getters.getStaff);
           self.$router.push({ name:'home'});
           self.isDisabled = true;
    
       }else{
            //console.log('Sorry wrong credentials');
            self.feedback = "Incorrect username or password";
            self.isDisabled = false;
            }

    });
	
     
       }else{
      this.feedback = "You must enter a username and password";
      }
     }
    }
};
</script>
   <style scoped>
   @import url('https://fonts.googleapis.com/css?family=Poppins:600&display=swap');
  
*{
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	
}

#body{
    font-family: 'Poppins', sans-serif;
	overflow: hidden;
	
}

.wave{
	position: fixed;
	bottom: 0;
	left: 0;
	height: 100%;
}

.container{
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap :7rem;
	padding: 0 2rem;
}

.img{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.login-content{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	text-align: center;
}

.img img{
	width: 500px !important;
	z-index: 1;
}

form{
	width: 360px;
}

.login-content img{
    height: 100px !important;
}

.login-content h2{
	margin: 15px 0 !important;
	color: #333 !important;
	text-transform: uppercase;
	font-size: 2.9rem !important;
	font-weight: 600;
}

.login-content .input-div{
	position: relative;
    display: grid;
    grid-template-columns: 7% 93% !important;
    margin: 25px 0 !important;
    padding: 5px 0 !important;
    border-bottom: 2px solid #d9d9d9;
}

.login-content .input-div.one{
	margin-top: 0;
}

.i{
	color: #d9d9d9;
	display: flex;
	justify-content: center;
	align-items: center;
}

.i i{
	transition: .3s;
}

.input-div > div{
    position: relative  !important;
	height: 45px  !important;
}

.input-div > div > h5{
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: #999 !important;
	font-size: 18px !important;
	transition: .3s;
}

.input-div:before, .input-div:after{
	content: '';
	position: absolute;
	bottom: -2px  !important;
	width: 0% !important;
	height: 2px !important;
	background-color: #38d39f;
	transition: .4s;
}

.input-div:before{
	right: 50% !important;
}

.input-div:after{
	left: 50% !important;
}

.input-div.focus:before, .input-div.focus:after{
	width: 50% !important;
}

.input-div.focus > div > h5{
	top: -5px !important;
	font-size: 15px !important;
}

.input-div.focus > .i > i{
	color: #38d39f !important;
}

.input-div > div > input{
	position: absolute !important;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	background: none;
	padding: 0.5rem 0.7rem;
	font-size: 1.2rem;
	color: #555 !important;
	font-family: 'poppins', sans-serif;
}

.input-div.pass{
	margin-bottom: 4px;
}

a{
	display: block;
	text-align: right;
	text-decoration: none;
	color: #999 !important;
	font-size: 0.9rem !important;
	transition: .3s;
}

a:hover{
	color: #38d39f;
}

.btn{
	display: block;
	width: 100%;
	height: 50px;
	border-radius: 25px;
	outline: none;
	border: none;
	background-image: linear-gradient(to right, #333, #333333f0, #333);
	background-size: 200%;
	font-size: 1.2rem !important;
	color: #fff;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	margin: 1rem 0;
	cursor: pointer;
	transition: .5s;
}
.btn:hover{
	background-position: right;
}


@media screen and (max-width: 1050px){
	.container{
		grid-gap: 5rem;
	}
}

@media screen and (max-width: 1000px){
	form{
		width: 290px;
	}

	.login-content h2{
        font-size: 2.4rem !important;
        margin: 8px 0 !important;
	}

	.img img{
		width: 400px !important;
	}
}

@media screen and (max-width: 900px){
	.container{
		grid-template-columns: 1fr;
	}

	.img{
		display: none;
	}

	.wave{
		display: none;
	}

	.login-content{
		justify-content: center;
	}
}
    </style>


